/** Origin tab label for labour cost services (matches Services page tabs). */
export default function getLabourCostServiceTabLabel(inhouse) {
  switch (Number(inhouse)) {
    case 1:
      return 'Production';
    case 2:
      return 'Install';
    case 3:
      return 'T/S';
    case 4:
      return 'Estimate Services';
    case 5:
      return 'Design Services';
    case 6:
      return 'Admin Services';
    case 0:
      return 'Sub contract';
    default:
      return 'Sub contract';
  }
}
